var TextShape = /** @class */ (function () {
    function TextShape() {
        this.verts = [];
    }
    return TextShape;
}());
export { TextShape };
